/**
  * 充值卡 接口的统一出口
  */
import axios from '.././http'; // 导入http中创建的axios实例
import qs from 'qs'; // 根据需求是否导入qs模块，把请求字段直接映射过来


// 接口请求地址
const api = '/c-api/jinfeixibi/';

const studymodule = {
    // 列表
    list (params) {
        return axios.get(api + 'studymodule/list', { params: params })
    },
    //添加
    create (params) {
        return axios.post(api + 'studymodule/create', qs.stringify(params))
    },
    //获取编辑信息
    detail (params) {
        return axios.get(api + 'studymodule/detail', { params: params })
    },
    edit (params) {
        return axios.post(api + 'studymodule/edit', qs.stringify(params))
    },
    // 修改状态
    sort (params) {
        return axios.post(api + 'studymodule/sort', qs.stringify(params))
    },
    remove (params) {
        return axios.post(api + 'studymodule/remove', qs.stringify(params))
    },
    status (params) {
        return axios.post(api + 'studymodule/status', qs.stringify(params))
    },
}


// 导出接口
export default studymodule